import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import TheHabitHero from "./sections/TheHabitHero";
import WhyChooseUs from "./sections/WhyChooseUs";
import FullServiceSolutions from "./sections/FullServiceSolutions";
import OurCorePromise from "./sections/OurCorePromise";
import ClinicalImpactByTheNumbers from "./sections/ClinicalImpactByTheNumbers";
import ReadyToProtectYourRoof from "./sections/ReadyToProtectYourRoof";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <TheHabitHero />
      <WhyChooseUs />
      <FullServiceSolutions />
      <OurCorePromise />
      <ClinicalImpactByTheNumbers />
      <ReadyToProtectYourRoof />
      <Footer />
    </div>;
}